<template>
  <div class="md-layout text-center">
    <!-- Login form -->
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card>
        <p slot="description" class="description">{{$lang.general.log_in_using_local_account}}</p>

        <md-field class="md-form-group" :class="{ 'md-error': !userValid }" slot="inputs">
          <md-icon>account_circle</md-icon>
          <label>{{$lang.general.user}}</label>
          <md-input v-model="localUser" @click="userValid = true" type="text"></md-input>
        </md-field>

        <md-field class="md-form-group" :class="{ 'md-error': !passwordValid }" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>{{$lang.general.password}}</label>
          <md-input v-model="localPassword" @click="passwordValid = true" type="password"></md-input>
        </md-field>

        <md-field class="md-form-group" slot="inputs">
          <md-icon>language</md-icon>
          <label>{{$lang.keys.language_select}}</label>
          <md-select v-model="langSelect">
            <md-option value="sk">{{$lang.general.slovak}}</md-option>
            <md-option value="en">{{$lang.general.english}}</md-option>
            <md-option value="de">{{$lang.general.deutsch}}</md-option>
          </md-select>
        </md-field>

        <md-button
          slot="footer"
          class="md-simple md-success md-lg"
          @click="localLogin"
        >{{$lang.keys.log_in}}</md-button>
      </login-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { LoginCard } from "@/components";
import { sha256 } from "js-sha256";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      firstname: null,
      localUser: null,
      localPassword: null,
      userValid: true,
      passwordValid: true,
      auth2: null,
      langSelect: "",
      initializationAttempts: 0,
      oAuthSigned: 0
    };
  },

  computed: {
    getLocation() {
      return this.$store.getters.getSettings.localization;
    }
  },

  watch: {
    langSelect: function(newLang, oldLang) {
      if (newLang !== oldLang) {
        this.changeLocation(newLang);
      }
    }
  },

  created() {
    this.langSelect = this.getLocation;

    window.addEventListener(
      "keyup",
      function(event) {
        if (event.keyCode === 13) {
          this.localLogin();
        }
      }.bind(this)
    );
  },

  methods: {
    pageRedirect() {
      this.$router.push({ path: "/dispatching" });
    },

    changeLocation(location) {
      this.$lang.setLang(location);
      this.$store.commit("setLocation", location);
    },

    showErrorMessage(msg) {
      this.$notify({
        message: msg,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "danger",
        timeout: 5000
      });
    },

    localLogin() {
      if (this.localUser && this.localPassword) {
        axios({
          method: "POST",
          url: this.$ENDPOINTS.API + "/login",
          data: {
            login: this.localUser,
            password: sha256.hex(this.localPassword)
          }
        })
          .then(response => {
            if (response.data.status === "OK") {

              this.$store.commit("setAuth", {
                id: 1,
                type: "local",
                user: this.localUser,
                expiration: new Date().getTime() + 172800000,
                token: response.data.data.token
              });

              this.pageRedirect();
            } else {
              this.showErrorMessage("Sig in process error.");
            }
          })
          .catch(error => {
            this.showErrorMessage(
              this.$lang.messages.login_credentials_incorrect
            );
            this.userValid = false;
            this.passwordValid = false;
          });
      } else {
        this.userValid = this.localUser ? true : false;
        this.passwordValid = this.localPassword ? true : false;
      }
    }
  },

  beforeDestroy() {
    this.localUser = null;
    this.localPassword = null;
  }
};
</script>

<style>
.md-select-value {
  margin-left: 12px;
}
</style>

<style type="text/css">
@keyframes ldio-739m8f7jx9t {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ldio-739m8f7jx9t div {
  box-sizing: border-box !important;
}
.ldio-739m8f7jx9t > div {
  position: absolute;
  width: 72px;
  height: 72px;
  top: 14px;
  left: 14px;
  border-radius: 50%;
  border: 8px solid #000;
  border-color: #fff9f5 transparent #fff9f5 transparent;
  animation: ldio-739m8f7jx9t 1s linear infinite;
}
.ldio-739m8f7jx9t > div:nth-child(2) {
  border-color: transparent;
}
.ldio-739m8f7jx9t > div:nth-child(2) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.ldio-739m8f7jx9t > div:nth-child(2) div:before,
.ldio-739m8f7jx9t > div:nth-child(2) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 8px;
  height: 8px;
  top: -8px;
  left: 24px;
  background: #fff9f5;
  border-radius: 50%;
  box-shadow: 0 64px 0 0 #fff9f5;
}
.ldio-739m8f7jx9t > div:nth-child(2) div:after {
  left: -8px;
  top: 24px;
  box-shadow: 64px 0 0 0 #fff9f5;
}
.loadingio-spinner-dual-ring-1dtfam0atym {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-739m8f7jx9t {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-739m8f7jx9t div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>
